import {useContext} from "react";
import { SecurityObjectContext } from "src/App";
import { PermissionType } from "src/types/security";

const useSecurityObject = () => {
    const { dictionarySecurityObject } = useContext(SecurityObjectContext);

    const isReadPermissionCode = (permissionCode: number) : boolean =>
        (permissionCode === PermissionType.Read) || (permissionCode === PermissionType.Write);

    const isWritePermissionCode = (permissionCode: number) : boolean =>
        (permissionCode === PermissionType.Write);

    const getPermissionTypeCode = (code: string) : number =>
        dictionarySecurityObject ?
            dictionarySecurityObject[code]?.codPermisoTipo ?? PermissionType.Write
            : PermissionType.None;

    const hasReadPermission = (code: string) : boolean => {
        const permissionTypeCode : number = getPermissionTypeCode(code);

        return isReadPermissionCode(permissionTypeCode);
    }

    const hasWritePermission = (code: string) : boolean => {
        const permissionTypeCode : number = getPermissionTypeCode(code);

        return isWritePermissionCode(permissionTypeCode);
    }

    const hasReadWorkflowPermission = (permissionWorkflowCode: number, code: string) : boolean =>
        isReadPermissionCode(permissionWorkflowCode) && hasReadPermission(code);

    const hasWriteWorkflowPermission = (permissionWorkflowCode: number, code: string) : boolean =>
        isWritePermissionCode(permissionWorkflowCode) && hasWritePermission(code);

    return { dictionarySecurityObject, hasReadPermission, hasWritePermission, hasReadWorkflowPermission, hasWriteWorkflowPermission };
};

export default useSecurityObject;
